import {Directive, ElementRef, HostListener} from '@angular/core';

@Directive({
  selector: '[appHighlight]'
})
export class HighlightDirective {

  constructor(private el: ElementRef) {

  }
    @HostListener('click')
    clickButton() {
        document.querySelectorAll('.item').forEach((item: HTMLElement) => {
          item.style.background = '#D9D9D9'
        })
        this.el.nativeElement.style.background = '#4BA6D3'
    }
}
